import Chooser from "~/components/shared/Chooser";
import Dropdown from "~/components/shared/Dropdown";
import PermissionDescription from "~/components/shared/PermissionDescription";
import PermissionSelectOptionDescriptions from "~/components/shared/PermissionSelectOptionDescriptions";

const MANAGE_AND_READ = "MANAGE_AND_READ";
const READ_ONLY = "READ_ONLY";

const getLabel = (value) => {
  switch (value) {
    case MANAGE_AND_READ:
      return "Full Access";
    case READ_ONLY:
      return "Read Only";
  }
};

const DropdownWithChooser = ({ saving, selected, withWorkflowPermission, onAccessLevelChange }) => (
  <Dropdown width={270}>
    <div className="underline-dotted inline-block cursor-pointer font-normal">
      {getLabel(selected)}
    </div>

    <Chooser selected={selected} onSelect={onAccessLevelChange}>
      <Chooser.SelectOption
        value={MANAGE_AND_READ}
        saving={saving === MANAGE_AND_READ}
        selected={selected === MANAGE_AND_READ}
        label={getLabel(MANAGE_AND_READ)}
        description={
          <PermissionSelectOptionDescriptions>
            <PermissionDescription allowed={true} permission="view runs" />
            <PermissionDescription allowed={true} permission="edit suite settings" />
            {!!withWorkflowPermission && (
              <PermissionDescription
                allowed={true}
                permission="create, edit and delete workflows"
              />
            )}
          </PermissionSelectOptionDescriptions>
        }
      />
      <Chooser.SelectOption
        value={READ_ONLY}
        label={getLabel(READ_ONLY)}
        saving={saving === READ_ONLY}
        selected={selected === READ_ONLY}
        description={
          <PermissionSelectOptionDescriptions>
            <PermissionDescription allowed={true} permission="view runs" />
            <PermissionDescription allowed={false} permission="edit suite settings" />
            {!!withWorkflowPermission && (
              <PermissionDescription
                allowed={false}
                permission="create, edit or delete workflows"
              />
            )}
          </PermissionSelectOptionDescriptions>
        }
      />
    </Chooser>
  </Dropdown>
);

const AccessLevel = ({ saving, teamSuite, withWorkflowPermission, onAccessLevelChange }) => {
  if (teamSuite.permissions.teamSuiteUpdate.allowed) {
    return (
      <DropdownWithChooser
        saving={saving}
        selected={teamSuite.accessLevel}
        withWorkflowPermission={withWorkflowPermission}
        onAccessLevelChange={onAccessLevelChange}
      />
    );
  }
  return <span className="dark-gray">{getLabel(teamSuite.accessLevel)}</span>;
};

export default AccessLevel;
